module.exports = __webpack_public_path__ + "img/form-8.a762367.jpg";